// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import { SelectBranchThirdPartyPartnerComponent } from './branch-select-3pl-partner-component';
import GrainIcon from '@material-ui/icons/Grain';
import Typography from '@material-ui/core/Typography/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  heading: {
    margin: theme.spacing(2)
  },
  fab: {
    width: '100%'
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

function BranchInformation({ branch }) {
  const partner = `Choose 3'PL Fulfilment Partner`;
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>3'PL Fulfilment Partners</b>
        </small>
      </Typography>

      <List className={classes.root}>
        <ListItem>
          <ListItemAvatar>
            <GrainIcon />
          </ListItemAvatar>
          <ListItemText primary={partner} secondary={null}></ListItemText>

          <ListItemSecondaryAction>
            {!open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClickOpen}>
                <EditIcon />
              </IconButton>
            )}
            {open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      {open && (
        <>
          <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
            <small>
              <b>Select / Change 3'PL Fulfilment Partner</b>
            </small>
          </Typography>
        </>
      )}

      {open && <SelectBranchThirdPartyPartnerComponent branch={branch} />}
    </div>
  );
}

export function AssignedThirdPartyComponent({ branch }) {
  return (
    <div>
      <BranchInformation branch={branch} />
    </div>
  );
}
